import { createSlice } from '@reduxjs/toolkit'

export const loaderSlice = createSlice({
  name: 'loader',
  initialState: {
    value: false,
  },
  reducers: {
    displayLoader: (state) => {
      state.value = true
    },
    hiddenLoader: (state) => {
      state.value = false
    }
  },
})

// Action creators are generated for each case reducer function
export const { displayLoader, hiddenLoader } = loaderSlice.actions

export default loaderSlice.reducer